import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { ReactComponent as CircleCross } from "../../../assets/icons/update_img_icons/circle_cross.svg";
import { ReactComponent as CircleRight } from "../../../assets/icons/update_img_icons/circle_right.svg";
import { ReactComponent as Cross } from "../../../assets/icons/update_img_icons/cross.svg";
import { ReactComponent as EditIcons } from "../../../assets/icons/update_img_icons/Edit_icons.svg";
import { ReactComponent as Trash } from "../../../assets/icons/update_img_icons/trash.svg";
import Image from "../../../assets/img/NS-00041.jpg";
import { useRef, useState } from "react";

const TableContainerComp = ({
  selectedFiles,
  setSelectedFiles,
  handleFileChange,
  handleSubmitBtn,
  handleDeleteImg,
  handleDrop,
  AddImagesBtn,
  uploadAndCheckDesign,
  designStatus = [],
  onClose,
  submitBtnName,
  isEditIcon = true,
  isLoading,
  onOpenCamera,
  // onclear,
  // fileInputRef,
  // handleDragOver,
  // handleDragLeave,
}) => {
  const fileInputRef = useRef(null);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedName, setEditedName] = useState("");

  const handleClear = () => {
    setSelectedFiles([]);
    onClose();
  };

  const handleEditClick = (index, name) => {
    setEditingIndex(index);
    setEditedName(name);
  };

  const handleNameChange = (e) => {
    setEditedName(e.target.value);
  };

  const handleSaveName = async (index) => {
    const updatedFiles = [...selectedFiles];

    const updatedFile = new File([selectedFiles[index]], `${editedName}.${selectedFiles[index].type.split("/")[1]}`, { type: selectedFiles[index].type });

    updatedFile.updatedName = editedName;
    updatedFiles[index] = updatedFile;
    setSelectedFiles(updatedFiles);

    setEditingIndex(null);

    await uploadAndCheckDesign(updatedFiles);
  };

  return (
    <Box
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      // onDragLeave={handleDragLeave}
      className="tableContainer"
      height="fit-content"
    >
      {/* Header */}
      <Box className="headerSection">
        <Typography variant="h6" className="headText" color="white">
          Images Uploaded
        </Typography>
        <Box display="flex" gap="30px" alignItems="center">
          {designStatus?.length !== 0 ? (
            <>
              <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                <Typography variant="p" mt="5px">
                  <CircleRight />
                </Typography>
                <Typography variant="p" fontSize="20px" color="white">
                  {designStatus?.filter((status) => status === "Design Found").length}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                <Typography variant="p" mt="5px">
                  <CircleCross />
                </Typography>
                <Typography variant="p" fontSize="20px" color="white">
                  {designStatus?.filter((status) => status === "Design Not Found").length}
                </Typography>
              </Box>
            </>
          ) : null}
          {AddImagesBtn && (
            <>
              {onOpenCamera && (
                <IconButton
                  onClick={onOpenCamera}
                  sx={{ color: "#fff", padding: "4px" }}
                >
                  <CameraAltIcon />
                </IconButton>
              )}
              <button className="btnText">
                <label style={{ cursor: "pointer" }} htmlFor="fileUpload">
                  Add Images
                </label>
              </button>
              <input id="fileUpload" type="file" ref={fileInputRef} multiple accept="image/png, image/jpg, image/jpeg, image/webp" style={{ display: "none" }} onChange={handleFileChange} />
            </>
          )}
          <Typography mt="5px" onClick={handleClear}>
            <Cross />
          </Typography>
        </Box>
      </Box>

      <Box sx={{ height: "21.12rem" }}>
        <Box className="tableSection">
          {selectedFiles?.map((data, index) => (
            <Box key={index} className="tableItems">
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <img src={URL.createObjectURL(data) || Image} alt="image" className="imageSize" />
                {editingIndex === index ? (
                  <input
                    type="text"
                    value={editedName}
                    onChange={handleNameChange}
                    onBlur={() => handleSaveName(index)}
                    onKeyDown={(e) => e.key === "Enter" && handleSaveName(index)}
                    autoFocus
                    className="editInput"
                  />
                ) : (
                  <Typography className="imageText" color="white">
                    {data.name.substring(0, data.name.lastIndexOf(".")) || "No name"}
                  </Typography>
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "60px" }}>
                {designStatus?.length !== 0 ? (
                  <Typography variant="p" className="imageText" sx={{ color: designStatus[index] === "Design Found" ? "#50C878" : "#E77B7B" }}>
                    {designStatus[index]}
                    {designStatus[index] === "Design Found" ? <CircleRight /> : <CircleCross />}
                  </Typography>
                ) : null}
                <Box sx={{ display: "flex", gap: "32px" }}>
                  {isEditIcon && (
                    <Typography sx={{ cursor: "pointer" }} onClick={() => handleEditClick(index, data.name.substring(0, data.name.lastIndexOf(".")))}>
                      <EditIcons />
                    </Typography>
                  )}
                  <Typography sx={{ cursor: "pointer" }} onClick={() => handleDeleteImg(index)}>
                    <Trash />
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Footer */}
      <Box display="flex" justifyContent="center" marginBottom={!AddImagesBtn && "-15px"}>
        <button
          className="submitBtn"
          onClick={handleSubmitBtn}
          disabled={isLoading}
          style={{
            backgroundColor: isLoading ? "#50C878" : "grey !important",
            cursor: isLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          {isLoading ? (
            <>
              <CircularProgress size={20} thickness={5} sx={{ color: "#fff" }} />
              Uploading...
            </>
          ) : (
            submitBtnName
          )}
          {!submitBtnName ?"Update Matching Images":""}
        </button>
      </Box>
    </Box>
  );
};

export default TableContainerComp;
